export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCIwrVANG0Pq5v8FC9bCFTAzThPgKtREhY',
    authDomain: 'looklashes-app.firebaseapp.com',
    databaseURL: 'https://looklashes-app.firebaseio.com',
    projectId: 'looklashes-app',
    storageBucket: 'looklashes-app.appspot.com',
    messagingSenderId: '864140123959',
    appId: "1:864140123959:web:e88e28f64f5662842cc4b2"
  },
  vapidKey: 'BIUqW_tJMY1dd0M8gVCHKl3LUnVFzqWCtpjM_izOkfD2AA1BazZSRdp9i0cVgWRXXDCM7o_85taCXyfRIhqltuE',
};
